import _ from 'lodash';
import { useSelector } from 'react-redux';
import { selectSharedMembersFilterOpen } from '../redux/slicers/uiSlicer';

export default function TopButtonArea(props) {
  const { topButtonList } = props;
  const isMembersFilterOpen = useSelector(selectSharedMembersFilterOpen);
  
  const disabled = !props.anySelected || props.loading;
  return (
    <div className={`top-buttons align-self-center d-flex ${props.customClassName ? props.customClassName : ""} ${props?.isSharedPage && isMembersFilterOpen ? 'memberSidebarOpen' : ''}`}>
      {props.hasData ? (
        <>
          {topButtonList && topButtonList.length > 0
            ? _.map(topButtonList, (item, index) => {
                const { element: Component, cardId, selectedList, ...cardProps } = item;

                if(!Component) return null;

                return (
                  <Component
                    key={`topActionButton${_.startCase(props.item)}${cardId}${index}}`}
                    cardType={props.item}
                    {...cardProps}
                    selectedList={selectedList || props.selectedList}
                    disabled={disabled || cardProps.disabled}
                  />
                );
              })
            : null}
        </>
      ) : null}
      {props.addNewButtonArea}
    </div>
  );
}
